<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col menu-container w-100 d-flex justify-content-between p-3">
        <h5 class="p-0 m-0" id="logo">BUILD WORKS</h5>
        <div class="d-flex align-items-center">
          <h5 class="p-0 my-0">Diego Franco</h5>
          <div class="dropdown">
            <div
              class
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <font-awesome-icon
                class="fa-lg ml-3"
                :icon="['far', 'comment']"
              />
              <span class="notification"></span>
            </div>
            <div
              class="dropdown-menu dropdown-menu-right lightShadow"
              aria-labelledby="dropdownMenuButton"
            >
              <Notifications />
            </div>
          </div>
          <div class="dropdown">
            <div
              class
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <font-awesome-icon class="fa-lg ml-3" :icon="['fas', 'bars']" />
            </div>
            <div
              class="dropdown-menu dropdown-menu-right lightShadow"
              aria-labelledby="dropdownMenuButton"
            >
              <a class="dropdown-item" href="#">Projects</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="#" v-on:click="handleSignOut"
                >Log Out</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <ul class="nav sub-menu-container w-100 py-1">
        <li class="nav-item">
          <router-link
            to="/home"
            class="nav-link"
            v-bind:class="{ active: this.$route.path === '/home' }"
            >Home</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            to="/calendar"
            class="nav-link"
            v-bind:class="{ active: this.$route.path === '/calendar' }"
            >Calendar</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            to="/search"
            class="nav-link"
            v-bind:class="{ active: this.$route.path === '/search' }"
            >All IRs</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            to="/docs"
            class="nav-link"
            v-bind:class="{ active: this.$route.path === '/docs' }"
            >Project Docs</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            to="/reports"
            class="nav-link"
            v-bind:class="{ active: this.$route.path === '/reports' }"
            >Reports</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            to="/metrics"
            class="nav-link"
            v-bind:class="{ active: this.$route.path === '/metrics' }"
            >Metrics</router-link
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");
import Notifications from "./Notifications";
export default {
  name: "Menu",
  components: {
    Notifications
  },
  methods: {
    handleSignOut() {
      var useThis = this;
      fb.auth
        .signOut()
        .then(function() {
          useThis.$router.push({ path: "/" });
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
#logo {
  font-weight: 800 !important;
  font-size: 20px !important;
}

.menu-container {
  background: #fff;
}

.sub-menu-container {
  background: #28334a;
}

.nav-link {
  color: #fff;
  transition: all 0.2s;
  cursor: pointer;
}

.nav-link:hover {
  color: #8c9ab6;
  transition: all 0.2s;
}

.active {
  color: #8c9ab6;
}

.n .sub-menu-container .nav-link:hover {
  color: #b1b1b1;
}

.notification {
  position: absolute;
  top: -1px;
  right: -3px;
  padding: 5px 5px;
  border-radius: 50%;
  background: #dc3545;
  color: white;
}

.dropdown {
  cursor: pointer;
}

.dropdown div svg {
  transition: all 0.2s;
}

.dropdown div svg:hover {
  opacity: 0.6;
  transition: all 0.2s;
}
</style>
